const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the add video component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Files} defines the Files resource
 */
app.directive('addScorm', ['Application', 'Authorization', 'Upload', 'Analyze', '$translate', function(Application, Authorization, Upload, Analyze, $translate) {
    return {
      restrict: 'E',
      scope: {
        scorm: '=',
        replaced: '&?'
      },
      template: require('../../../templates/directives/cms/add-scorm.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.currentUser = Authorization.getAuthToken().user;
          self.translations = {};

          self.uploaderId = 'file-upload';

          self.checkBrowse = function() {
            if (!$scope.scorm._id) {
              self.browseFile();
              return;
            }
            self.showConfirm = true;
          };

          self.browseFile = function() {
            self.showConfirm = false;
            document.getElementById(self.uploaderId).click();
          };

          $scope.$watch('addScorm.file', function(newVal, oldVal) {
            if (newVal && !newVal.$error) {
              self.onFileSelect(self.file);
            }
          });

          self.onFileSelect = function(uploaded) {
            if (uploaded.size > 10000000000) {
              Application.messaging.addMessage({type: 'error', text: 'Error. This file exceeds the 500mb limit.', duration: 5});
              return;
            }
            if (uploaded.type === '') {
              uploaded.type = 'application/octet-stream';
            }

            var newScormContent = {
              title: 'Title Pending',
              user: self.currentUser._id,
              self_hosted: true
            };
            var replacing = $scope.scorm && $scope.scorm._id;
            var url = Application.API + '/learn/v3/scorm/content';
            if (replacing) {
              url = url + '/' + $scope.scorm._id + '/replace';
            }

            Upload.upload({
              url: url,
              method: 'POST',
              data: newScormContent,
              file: uploaded
            }).progress(function(evt) {
              var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
              self.loadingBar = true;
              self.loadingPercent = percent;
              self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
            }).success(function(data) {
              self.imageLoading = false;
              if (data.status) {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.scorm.upload_error'], duration: 5});
                self.file = null;
                self.loadingPercent = 0;
                self.progress = {'width': '0%'};
              } else {
                self.loadingBar = false;
                self.changing = false;
                if (!replacing) {
                  var rating_configuration;
                  if ($scope.scorm.rating_configuration) {
                    rating_configuration = $scope.scorm.rating_configuration;
                  }
                  $scope.scorm = data;
                  $scope.scorm.rating_configuration = rating_configuration;
                  Analyze.record({resource: 'creations'}, {document: $scope.scorm._id, type: 'scorm-content'});
                  Application.analyticsProvider.trackEvent('scorm_content_created', {content: $scope.scorm._id, type: 'scorm-content', title: $scope.scorm.title});
                }
                if (replacing && $scope.replaced) {
                  $scope.replaced();
                  Analyze.record({resource: 'modifications'}, {document: $scope.scorm._id, type: 'scorm-content'});
                  Application.analyticsProvider.trackEvent('scorm_content_updated', {content: $scope.scorm._id, type: 'scorm-content', title: $scope.scorm.title});
                }
              }
            }).catch(function(error) {
              console.log('An error occured while uploading the SCORM package', error);
              self.imageLoading = false;
              self.file = null;
              self.loadingPercent = 0;
              self.progress = {'width': '0%'};
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.scorm.upload_error'], duration: 5});
            });

          };

          $translate(['edit.scorm.upload_error']).then(function(translations) {
            self.translations = translations;
          });


        }],
      controllerAs: 'addScorm'
    };
  }]);
